import { AfterViewInit, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { LegacyApiService } from '@lmc-app/core/services/legacy-api.service';
import { Router } from '@angular/router';
import { CellClickedEvent } from 'ag-grid-community';
import { ButtonCellRendererComponent } from '@lmc-app/custom-table/button-cell-renderer/button-cell-renderer.component';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { dateFilterAgGrid } from '@lmc-app/utils/filter-functions';
import { CustomAssignCollectorsComponent } from './custom-assign-collectors/custom-assign-collectors.component';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { selectUser, State } from '@lmc-app/store';
import { User } from '@lmc-app/shared/interface/user.interface';
import { LoanMetaService } from '@lmc-app/core/services/loan-meta.service';

@Component({
	selector: 'app-collection-list',
	templateUrl: './collection-list.component.html',
	styleUrls: ['./collection-list.component.scss'],
})
export class CollectionListComponent implements OnDestroy, OnInit {
	rowClassRules = {
		'requested-row': (params) => params?.data?.current_principal_balance < 1500,
	};
	adminDataSubscription: Subscription;
	individualDataSubscription: Subscription;

	defaultColDef_Collection: any;
	public columnDefs_Collection = [];
	public rowData_Collection;
	public gridApi_Collection;
	public gridColumnApi_Collection;
	public gridOptions_Collection;
	public multiple?: 'single' | 'multiple' | undefined;
	maturedSelected = 'basic';

	currentUser: User | null = null;
	adminView = false; // Component permission flag
	filtered_list: any; // The final list for display
	showLoader: boolean;
	showEmptyResults: boolean;
	past_date = new Date();

	allSelected = 'accent';
	brokenSelected = 'basic';
	portfolios = ['SPV', 'MFT', 'Debenture', 'QVEST'];
	unTouchedSelected = 'basic';

	hideNSFDate = false;
	isAssignCollectorAllowed: boolean = false;
	selectedValue: any;
	unTouchedDays: number = 0;
	isAssigned: boolean = false;
	private readonly _onDestroy = new Subject<void>();
	// private loanMetaService = inject(LoanMetaService);
	clickedCellLoanNumber:string = '';
	constructor(
		private apiService: LegacyApiService,
		private router: Router,
		public dialog: MatDialog,
		private store: Store<State>,
		private loanMetaService: LoanMetaService
	) {}
	ngOnInit(): void {
		this.store
		.select(selectUser)
		.pipe(takeUntil(this._onDestroy))
		.subscribe((user: User | null) => {
			if (user) {
				this.showLoader = true;
				this.currentUser = user;
				this.apiService.getBtnPermission().subscribe((res: any) => {
					const collectionSetting = JSON.parse(res[0]?.['collection_list']);
					this.isAssignCollectorAllowed = collectionSetting['CollectionList'][
						'assignCollectorPermission'
					].includes(this.currentUser.employeeID);
					this.unTouchedDays =
						collectionSetting['CollectionList']['untouchedDays'];
					this.adminView =
						user.permissions?.collection_list === null
							? false
							: user.permissions?.collection_list ?? false; // Defining Admin from the permission_component table
					this.collectionAgGrid();
					// this.collectionView(this.adminView);
					this.collectorList();
				});
			}
		});
	}

	collectionAgGrid() {
		this.columnDefs_Collection = [
			{
				headerName: '',
				field: '',
				pinned: 'left',
				width: 50,
				hide: !this.isAssignCollectorAllowed,
				checkboxSelection: true,
			},
			{
				headerName: 'Loan Number',
				field: 'Loan Number',
				filter: 'agTextColumnFilter',
				pinned: 'left',
				width: 140,
				onCellClicked: (event: CellClickedEvent) =>
					{	
						// this.clickedCellLoanNumber= event?.value;
						// this.openLoanMeta(event?.data?.['Loan Number']);
						this.openLoanMeta(event?.value);
					},
				cellStyle: { cursor: 'pointer', color: '#116abd' },
			},
			{
				headerName: 'Name',
				field: 'Name',
				filter: 'agTextColumnFilter',
				width: 200,
			},
			{
				headerName: 'Province',
				field: 'Province',
				filter: 'agTextColumnFilter',
				width: 120,
			},
			{
				headerName: 'Homeowner',
				field: 'Homeowner',
				filter: 'agTextColumnFilter',
				width: 130,
			},
			{
				headerName: 'Past Due Balance',
				field: 'Past Due Balance',
				filter: 'agNumberColumnFilter',
				width: 160,
			},
			{
				headerName: 'Days past due',
				field: 'Days past due',
				filter: 'agNumberColumnFilter',
				width: 130,
			},
			{
				headerName: 'Current Principal Balance',
				field: 'Current Principal Balance',
				filter: 'agNumberColumnFilter',
				width: 120,
			},
			{
				headerName: 'Collector',
				field: 'Collector',
				filter: 'agTextColumnFilter',
				width: 120,
			},
			{
				headerName: 'Last PTP Date',
				field: 'Last PTP Date',
				filter: 'agDateColumnFilter',
				width: 130,
				filterParams: {
					comparator: (filterDate, cellValue) =>
						dateFilterAgGrid(filterDate, cellValue),
					browserDatePickerDateFormat: 'yyyy-mm-dd',
				},
				// valueGetter: (params) =>
				// 	params?.data?.Last_PTP_Date !== null ? params?.data?.Last_PTP_Date : 'Past',
			},
			{
				headerName: 'Last NSF Date',
				field: 'Last NSF Date',
				filter: 'agDateColumnFilter',
				width: 130,
				filterParams: {
					comparator: (filterDate, cellValue) =>
						dateFilterAgGrid(filterDate, cellValue),
					browserDatePickerDateFormat: 'yyyy-mm-dd',
				},
				// valueGetter: (params) =>
				// 	params?.data?.Last_PTP_Date !== null ? params?.data?.Last_PTP_Date : 'Past',
			},
			{
				headerName: 'Note created',
				field: 'Note created',
				filter: 'agDateColumnFilter',
				width: 130,
				filterParams: {
					comparator: (filterDate, cellValue) =>
						dateFilterAgGrid(filterDate, cellValue),
					browserDatePickerDateFormat: 'yyyy-mm-dd',
				},
			},
			{
				headerName: 'Loan Group',
				field: 'Loan Group',
				filter: 'agTextColumnFilter',
				width: 130,
			},
			{ headerName: 'loan_group_no', field: 'loan_group_no', hide: true },
			{ headerName: 'Total PTP Amount', field: 'Total PTP Amount', width: 130 },
			{
				headerName: 'Documents',
				field: 'Loan Number',
				cellRenderer: ButtonCellRendererComponent,
				width: 130,
				cellRendererParams: {
					label: 'Folder Open',
					matIconLabel: 'folder_open',
					clicked: (data: any) => {
						this.openDrive(data?.['Loan Number']);
					},
				},
			},
		];
		this.defaultColDef_Collection = {
			resizable: true,
		};
	}

	collectorList(){
		this.filtered_list = '';
			this.adminDataSubscription = this.apiService
				.collectionList(this.currentUser!.employeeID)
				.subscribe((res) => {
					this.filtered_list = res;
					this.gridApi_Collection?.setRowData(this.filtered_list);
					this.hideCollectorName();
					this.hideNSFDateCol();
					this.rowData_Collection = this.filtered_list;
					this.showLoader = false;
					this.showEmptyResults = false;
					// }
				});	
	}

	// collectionView(isAdmin) {
	// 	if (isAdmin) {
	// 		// If the component is set to try on permission_component table
	// 		this.filtered_list = '';
	// 		this.adminDataSubscription = this.apiService
	// 			.getAdminCollectionList(this.currentUser!.employeeID)
	// 			.subscribe((res) => {
	// 				this.filtered_list = res;
	// 				this.gridApi_Collection?.setRowData(this.filtered_list);
	// 				this.hideCollectorName();
	// 				this.hideNSFDateCol();
	// 				this.rowData_Collection = this.filtered_list;
	// 				this.showLoader = false;
	// 				this.showEmptyResults = false;
	// 				// }
	// 			});
	// 	} else {
	// 		// If false then its collector based list
	// 		this.filtered_list = '';
	// 		this.individualDataSubscription = this.apiService
	// 			.getCollectionList(this.currentUser!.employeeID)
	// 			.subscribe((res) => {
	// 				this.filtered_list = res;
	// 				this.gridApi_Collection?.setRowData(this.filtered_list);
	// 				this.hideCollectorName();
	// 				this.hideNSFDateCol();
	// 				this.rowData_Collection = this.filtered_list;
	// 				this.showLoader = false;
	// 				this.showEmptyResults = false;
	// 			});
	// 	}
	// }

	brokenPTPList() {
		this.hideNSFDate = true;
		const nsfList = this.filtered_list.filter(
			(item) => item['ptp_days'] > 0 && item['ptp_days'] < 14
		);
		this.gridApi_Collection?.setRowData(nsfList);
		this.hideCollectorName();
		this.hideNSFDateCol();
		this.rowData_Collection = nsfList;
		this.brokenSelected = 'accent';
		this.allSelected = 'basic';
		this.maturedSelected = 'basic';
		this.unTouchedSelected = 'basic';
	}

	filterPortfolio(e) {
		switch (e.value) {
			case 'SPV':
				this.hideNSFDate = false;
				const spvList = this.filtered_list.filter((item) =>
					item['Loan Group'].includes('SPV')
				);
				this.gridApi_Collection?.setRowData(spvList);
				this.hideCollectorName();
				this.hideNSFDateCol();
				this.rowData_Collection = spvList;
				break;
			case 'MFT':
				this.hideNSFDate = false;
				const mftList = this.filtered_list.filter(
					(item) => item['loan_group_no'] === 3 || item['loan_group_no'] === 16
				);
				this.gridApi_Collection?.setRowData(mftList);
				this.hideCollectorName();
				this.hideNSFDateCol();
				this.rowData_Collection = mftList;
				break;
			case 'Debenture':
				this.hideNSFDate = false;
				const debentureList = this.filtered_list.filter(
					(item) => item['loan_group_no'] === 1 || item['loan_group_no'] === 27
				);
				this.gridApi_Collection?.setRowData(debentureList);
				this.hideCollectorName();
				this.hideNSFDateCol();
				this.rowData_Collection = debentureList;
				break;
			case 'QVEST':
				this.hideNSFDate = false;
				const qvestList = this.filtered_list.filter(
					(item) => item['loan_group_no'] === 50 || item['loan_group_no'] === 51
				);
				this.gridApi_Collection?.setRowData(qvestList);
				this.hideCollectorName();
				this.hideNSFDateCol();
				this.rowData_Collection = qvestList;
				break;
			default:
				this.hideNSFDate = false;
				this.gridApi_Collection!.setFilterModel(null);
				this.gridApi_Collection?.setRowData(this.filtered_list);
				this.hideCollectorName();
				this.hideNSFDateCol();
				this.rowData_Collection = this.filtered_list;
		}
	}

	unTouched() {
		const today = new Date();
		const unTouchedDate = new Date();
		unTouchedDate.setDate(today.getDate() - this.unTouchedDays);
		this.hideNSFDate = false;
		console.log(unTouchedDate.toISOString().slice(0, 10));
		const unTouchedList = this.filtered_list.filter((item) => {
			return item['Note created'] < unTouchedDate.toISOString().slice(0, 10);
		});
		this.gridApi_Collection?.setRowData(unTouchedList);
		this.hideCollectorName();
		this.hideNSFDateCol();
		this.rowData_Collection = unTouchedList;
		this.unTouchedSelected = 'accent';
		this.allSelected = 'basic';
		this.brokenSelected = 'basic';
		this.maturedSelected = 'basic';
	}

	resetFilters() {
		this.hideNSFDate = false;
		this.gridApi_Collection!.setFilterModel(null);
		this.gridApi_Collection?.setRowData(this.filtered_list);
		this.hideCollectorName();
		this.hideNSFDateCol();
		this.rowData_Collection = this.filtered_list;
		this.brokenSelected = 'basic';
		this.allSelected = 'accent';
		this.maturedSelected = 'basic';
		this.unTouchedSelected = 'basic';
		this.selectedValue = null;
	}

	maturedList() {
		this.hideNSFDate = false;
		const maturedList = this.filtered_list.filter(
			(item) => item['Matured'] !== null
		);
		this.gridApi_Collection?.setRowData(maturedList);
		this.hideCollectorName();
		this.hideNSFDateCol();
		this.rowData_Collection = maturedList;
		this.maturedSelected = 'accent';
		this.brokenSelected = 'basic';
		this.allSelected = 'basic';
		this.unTouchedSelected = 'basic';
	}

	hideCollectorName() {
		return this.adminView
			? this.gridColumnApi_Collection?.setColumnsVisible(['Collector'], true)
			: this.gridColumnApi_Collection?.setColumnsVisible(['Collector'], false);
	}

	hideNSFDateCol() {
		return this.hideNSFDate
			? this.gridColumnApi_Collection?.setColumnsVisible(
					['Last NSF Date'],
					true
			  )
			: this.gridColumnApi_Collection?.setColumnsVisible(
					['Last NSF Date'],
					false
			  );
	}

	// Open the Drive
	openDrive(loan_number: any) {
		this.apiService.getZOHOLoanNumberDrive(loan_number).subscribe((res) => {
			console.log(res);
			if (res['message']['statusCode'] == '200') {
				let arr = JSON.parse(res.message.body);
				window.open(arr.data[0]['gdriveextension__Drive_URL']);
			}
		});
	}

	onGridReady(params) {
		this.gridApi_Collection = params.api;
		this.gridColumnApi_Collection = params.columnApi;
		this.gridApi_Collection?.setRowData(this.filtered_list);
		this.hideCollectorName();
		this.hideNSFDateCol();
		this.rowData_Collection = this.filtered_list;
	}

	//INCLUDE THIS IN THE SEARCH COMPONENT TO OPEN LOAN META FOR SPECIFIC LOAN FOR NLS (NEW COLOUMN FOR NLS OPEN)
	openLoanMeta(loan_number: string) {
		let collection_queue = [];
		this.gridApi_Collection.forEachNodeAfterFilterAndSort(
			(rowNode, index) => {
				collection_queue.push(rowNode?.data?.['Loan Number']);
			}
		);
		this.loanMetaService.setQueue(collection_queue, loan_number, true);
		this.router.navigate(['loan-meta']);
	}

	customAssignCollectors() {
		let selectedRows = this.gridApi_Collection.getSelectedRows();
		if (selectedRows.length === 0) {
			alert('Please select the loan(s).');
		} else {
			const dialogRef = this.dialog.open(CustomAssignCollectorsComponent, {
				width: '500px',
				data: selectedRows,
			});
			dialogRef.afterClosed().subscribe((result) => {
				if (result) {
					// this.collectionView(this.adminView);
					this.collectorList();
				}
			});
		}
	}

	ngOnDestroy() {
		this._onDestroy.next();
		this._onDestroy.complete();
		this.adminDataSubscription?.unsubscribe();
		this.individualDataSubscription?.unsubscribe();
		console.log('Collection List Data Unsubscribed!');
	}
}
